import axios from 'axios'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import Response from '../../../Common/Response'
import { PUBLIC_ERROR_CODE } from '../../../../Error/Constants'
import { GetPublicErrorCode } from '../../../../Error/Handler'

/**
 * 렌터 타임 로그 목록 조회
 * templateId or videoId 중 1가지 값 필수
 * @param {string} adminToken 필수
 * @param {string | null} templateId 
 * @param {string | null} videoId 
 * @param {string | null} description 
 * @param {string | null} excludedScriptName 
 * @param {Number | null} offset 기본값 0
 * @param {Number | null} limit 기본값 20
 */
const GetRenderTime = async (
    adminToken,
    templateId = null,
    videoId = null,
    description = null,
    excludedScriptName = null,
    offset = null,
    limit = null
) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/templates/rendertime`
        const params = {
            tId: templateId,
            vId: videoId,
            des: description,
            script: excludedScriptName
        }
        if (offset) params.offset = offset
        if (limit) params.limit = limit
        const config = {
            params,
            headers: { Authorization: `Bearer ${adminToken}` }
        }
        const response = await axios.get(url, config)
        /*
            Response Data
            [
                {
                    "_id": "62f0a994820c1f003b3fcda3",
                    "templateId": "62f0a2e816e39300342ed1ba",
                    "videoId": "62f0a6a016e39300342ed1c7",
                    "startRenderDate": "2022-08-08T06:08:18.268Z",
                    "endRenderDate": "2022-08-08T06:13:40.537Z",
                    "renderTime": 322.269,
                    "scriptExecuteTime": 178.343,
                    "executedScriptName": "video",
                    "description": "RenderVideo",
                    "userId": "5f90f688edeb6d0034420bbe",
                    "videoRenderTime": 143.92600000000002,
                    "isGroupRendering": "false",
                    "templateName": "upload-log-test-1"
                },
                ...
            ]
        */
        const result = (response.status === 200)
        const data = response.data.data
        return new Response(result, data)
    }
    catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * 템플릿 강제 싱글 렌더 여부 변경
 * @param {string} adminToken 필수
 * @param {string} templateId 필수
 * @param {boolean} value 필수
 * @returns 
 */
const PatchUpdateMustSingleRender = async (adminToken, templateId, value) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/templates/${templateId}/must-single-render`
        const body = { value: Boolean(value) }
        const config = { headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.patch(url, body, config)
        /*
            Response Data
            {

            }
        */
        const result = (response.status === 200)
        const data = response.data.data
        return new Response(result, data)
    }
    catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * 프리미엄 템플릿 여부 업데이트
 * @param {string} adminToken 필수
 * @param {string} templateId 필수
 * @param {boolean} isPremium 필수
 * @returns {Promise<Response>}
 */
const PatchIsPremium = async (adminToken, templateId, isPremium) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/templates/${templateId}/is-premium`
        const body = { isPremium }
        const config = { headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.patch(url, body, config)
        const result = (response.status === 200)
        const data = response.data.data
        return new Response(result, data)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

export default {
    GetRenderTime,
    PatchUpdateMustSingleRender,
    PatchIsPremium
}